/** @format */

import { getLocaleFromKeycloakClient } from './keycloakLocale';

const STORAGE_KEY = 'portal_accept_language';

function safeGetLocal() {
  if (typeof localStorage === 'undefined') return null;
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

function migrateFromSessionIfNeeded() {
  if (typeof localStorage === 'undefined' || typeof sessionStorage === 'undefined') return;
  try {
    if (localStorage.getItem(STORAGE_KEY) != null) return;
    const legacy = sessionStorage.getItem(STORAGE_KEY);
    if (legacy != null && String(legacy).trim() !== '') {
      localStorage.setItem(STORAGE_KEY, String(legacy).trim());
      sessionStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    // ignore
  }
}

export function setPersistedAcceptLanguage(lng) {
  if (typeof localStorage === 'undefined') return;
  if (lng != null && String(lng).trim() !== '') {
    try {
      localStorage.setItem(STORAGE_KEY, String(lng).trim());
    } catch {
      // ignore
    }
  }
}

export function clearPersistedAcceptLanguage() {
  if (typeof localStorage === 'undefined') return;
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}

export function getPersistedAcceptLanguage() {
  migrateFromSessionIfNeeded();
  const v = safeGetLocal();
  return v != null && String(v).trim() !== '' ? String(v).trim() : null;
}

/**
 * Order: localStorage (explicit user choice) > Keycloak token claims > i18n > en.
 * Reload keeps the UI choice over the token when they differ.
 */
export function resolveAcceptLanguage(i18nInstance, keycloakClient) {
  const persisted = getPersistedAcceptLanguage();
  if (persisted) return persisted;
  const fromKc = keycloakClient?.token ? getLocaleFromKeycloakClient(keycloakClient) : null;
  if (fromKc) return fromKc;
  return i18nInstance?.language || 'en';
}
